import React from "react";
import { Typography } from "@mui/material";

/**
 * `wrapBoldText` takes a text and iterates through it to style the words wrapped in `*`
 * @param {string} text - The text to parse
 * @param {string} color - The color of the bold text (default: "primary")
 * @returns {JSX.Element} a JSX element
 * @example
 * wrapBoldText("Hello *World*"); // Hello <Typography component="span" color="primary" variant="subtitle2">World</Typography>
 */
const wrapBoldText = (text, color = "primary") => (
  <>
    {text.split(" ").map((text, index) => {
      if (text.startsWith("*") && text.endsWith("*")) {
        return (
          <Typography component="span" color={color} variant="subtitle2" key={index}>
            {text.slice(1, -1)}{" "}
          </Typography>
        );
      }

      return text + " ";
    })}
  </>
);

export default wrapBoldText;
